import React, { useEffect, useState } from 'react';
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import courseback from "../../../assets/course-back.jpg";
import { useParams } from 'react-router-dom';
import { GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { App, Button, Col, Form, Input, Modal, Row, Tabs } from 'antd';

// @ts-ignore: CSS side-effect import without declaration file
import './commonCourse.css';
import EligibilityCheckForm from '../eligibilitycheckForm';
import course1 from "../../../assets/course1.webp";
import course2 from "../../../assets/eligibility_check.webp";
import course3 from "../../../assets/course2.webp";
import course4 from "../../../assets/course3.webp";
import defalut from "../../../assets/fixed_mage.png";
import EnrollModal from '../../booking-payment/enrollmentModel';
import why1 from '../../../assets/why1.webp';
import whycfe from '../../../assets/course2.webp';
import FormItem from 'antd/es/form/FormItem';

import CourseDisplayCard from './courseDisplayCard';
function Ctp() {
    const { id } = useParams();
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [courseDetails, setCourseDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('eligibility');
    const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                name: values.name,
                email: values.email,
                message: values.message,
                phone: values.phone,
                Course_id: Number(id),
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_COURSE_ENQUIRY, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const tabItems = [
        {
            key: 'eligibility',
            label: <div className="tab-label">Eligibility Check</div>,
            children: (
                <div className="tab-content eligibility-tab">
                    <div className="tab-text">
                        <h2>Eligibility Check</h2>
                        <ul>
                            <li>Meet the <strong>AFP eligibility requirements</strong> for the CTP certification</li>
                            <li>Eligibility is based on a combination of <strong>education and relevant professional work experience.</strong></li>
                            <li>Candidates with a Bachelor's or Master's degree in finance, accounting, business, or related fields are encouraged to apply. </li>
                            <li>Relevant experience in<strong> Treasury, Finance, Banking, Accounting, Corporate Finance, Cash Management, Risk Management, or Financial Operations is accepted.</strong>  </li>
                            <li>Candidates must satisfy the eligibility criteria established by the<strong>the Association for Financial Professionals (AFP)</strong>  before applying for the examination .</li>
                            <li>Meantoir Global Academy offers a <strong>FREE CTP eligibility assessment</strong> before applying for the examination</li>
                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course2} alt="CTP certification India" />
                    </div>
                </div>

            ),
        },
        {
            key: 'exam',
            label: <div className="tab-label">Pattern and Scoring</div>,
            children: (
                <div className="tab-content exam-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                <strong>Exam Format: </strong>Multiple Choice Questions (MCQs) </li>
                            <li> <strong>Total Questions:</strong>170 Questions (150 scored + 20 unscored pretest questions)  </li>
                            <li><strong>Exam Duration:</strong>3.5 Hours (210 Minutes) </li>
                            <li><strong>Mode of Examination: </strong>Pearson VUE Testing Centers  </li>
                            <li><strong>Question Type: </strong>Practical, application-based, and scenario-driven questions. </li>
                            <li><strong>Negative Marking: </strong>No Negative Marking </li>
                            <li><strong>Result: </strong>Pass/Fail </li>

                        </ul>
                        <p>

                            The CTP examination evaluates your expertise across key<b>
                                treasury management domains, including Treasury Management, Cash Management,
                                Liquidity Management, Working Capital Management, Corporate Finance, Financial Risk
                                Management, Capital Markets, Treasury Operations, Payments, Treasury Controls, Ethics,
                                and Treasury Technology.</b>
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course1} alt="CTP certification India" />
                    </div>
                </div>

            ),
        },

        {
            key: 'outcomes',
            label: <div className="tab-label">Career Opportunities</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">

                        <ul>
                            <li>Treasury Analyst</li>
                            <li>Treasury Manager</li>
                            <li>Cash Manager</li>
                            <li>Corporate Treasurer</li>
                            <li>Assistant Treasurer</li>
                            <li>Treasury Operations Analyst</li>
                            <li>Treasury Consultant</li>
                            <li>Working Capital Manager</li>
                            <li>Cash & Liquidity Analyst</li>
                            <li>Corporate Finance Manager</li>
                            <li>Financial Planning & Analysis (FP&A) Analyst</li>
                            <li>Financial Risk Analyst</li>
                            <li>Investment Analyst</li>
                            <li>Banking Relationship Manager</li>
                            <li>Corporate Banking Officer</li>
                            <li>Finance Manager</li>
                            <li>Treasury Risk Manager</li>
                            <li>Capital Markets Analyst</li>
                            <li>Commercial Finance Analyst</li>
                            <li>Financial Controller</li>
                        </ul>
                        <p>
                            <b>Top Hiring Sectors: </b>Fortune 500 Companies, Multinational Corporations (MNCs), Global Banks, Investment Banks, Big 4 Firms, Financial Institutions, Consulting Firms, Manufacturing Companies, Technology Companies, Healthcare Organizations, Energy Companies, Retail Corporations, and Global Capability Centers (GCCs).
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course3} alt="CTP certification India" />
                    </div>
                </div>

            ),
        },
        {
            key: 'target-audiance',
            label: <div className="tab-label">CTP Exam Cost</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li><strong>AFP Member (Early Registration):</strong> USD $975</li>
                            <li><strong>AFP Member (Standard Registration):</strong> USD $1,075</li>
                            <li><strong>Non-Member (Early Registration):</strong> USD $1,450</li>
                            <li><strong>Non-Member (Standard Registration):</strong> USD $1,550</li>

                            <li>
                                <strong>Exam Includes:</strong>
                                <ul>
                                    <li>CTP Examination</li>
                                    <li>Digital CTP Exam Prep Platform</li>
                                    <li>AFP Learning Resources</li>
                                    <li>One Exam Attempt</li>
                                </ul>
                            </li>

                            <li><strong>Exam Retake:</strong> Available during future testing windows with applicable fees.</li>
                            <li><strong>Recertification:</strong> Every 3 years by earning Continuing Education Credits (CECs).</li>
                        </ul>
                        <p>
                            <b>Note:</b> Exam fees are subject to change by the <b>Association for Financial Professionals (AFP)</b>.
                            Contact <b>Meantoir Global Academy, Kochi</b> for the latest pricing, eligibility guidance, and enrollment support.
                        </p>
                    </div>
                    <div className="tab-image">
                        <img src={course4} alt="CTP course Kerala" />
                    </div>
                </div>
            ),
        },


    ];
    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            try {
                const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});
                setCourseDetails(response?.data);
                console.log("Course Response:", response);
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCourseDetails();
        }
    }, [id]);
    const [openSection, setOpenSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };

    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation();
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null);
    };

    const whyctptexts = [
        <><strong>Globally recognized treasury certification</strong> trusted by <strong>30,000+ Certified Treasury Professionals </strong>worldwide.</>,
        <>Recognized as the <strong>gold standard in Treasury & Cash Management </strong>by leading multinational organizations.</>,
        <>Preferred by Fortune<strong> 500 Companies, Global Banks, Big 4 Firms, MNCs, Consulting Firms, and Financial Institutions.</strong></>,
        <>Develop expertise in <strong>Treasury Management, Cash Management, Liquidity Management, Working Capital, Corporate Finance, Payments, Investments, and Financial Risk Management.</strong></>,
        <>Future-ready, AI-resilient career requiring strategic financial decision-making and treasury leadership skills.</>,
        <>Opens doors to high-paying roles in <strong>Corporate Treasury, Finance, Banking, Treasury Operations, and Financial Planning.</strong></>,
        <>Prepare and become<strong> CTP exam-ready within 3–4 months</strong> with expert coaching and structured learning. </>,
        <>Enhance your credibility and accelerate career growth with one of the world's most respected treasury certifications.  </>,
    ]


    const whyTexts = [
        "Kerala's First & Only Certified Treasury Professional (CTP) coaching provider",
        "One of the most affordable CTP coaching programs in India",
        "Expert faculty with extensive Corporate Treasury, Banking & Finance industry experience",
        "Latest AFP-aligned study materials and structured learning plans",
        "Comprehensive mock exams with real exam-level questions",
        "Complete guidance from eligibility assessment to CTP certification",
        "Specialized training in Treasury Management, Cash Management, Liquidity, Working Capital & Financial Risk",
        "Strong placement support for opportunities in Fortune 500 Companies, Big 4 Firms, Global Banks & MNCs",
        "100% Placement Assistance",
        "Premium Online & Offline Batches (Malayalam & English)",
        "Mentorship from Corporate Treasurers, CFOs, Banking Professionals & Big 4 Experts",
        "Resume Building, LinkedIn Optimization, Interview Preparation & Career Mentoring",
    ];
    return (
        <div>
            <Header />
            <div className="course-page-container">
                <div className="course-hero">
                    <img src={courseback} alt="CTP course Kerala" className="course-hero-image" />
                    <div className="course-hero-overlay"></div>

                    <div className="course-hero-inner">
                        {/* Left Content */}
                        <div className="course-hero-content left-content">
                            <h1>
                                {isLoading
                                    ? "Loading..."
                                    : courseDetails?.course_title
                                        ?.replace(/\s*\(.*?\)/, "") || "Certified Treasury Professional Course in Kerala, India"}

                                {!isLoading && courseDetails?.course_title?.match(/\(.*?\)/) && (
                                    <h1>
                                        {courseDetails.course_title.match(/\(.*?\)/)?.[0]}
                                    </h1>
                                )}
                            </h1>
                            <i>(Globally Recognized Treasury & Cash Management Expert)</i>
                            <p>{courseDetails?.course_duration || "1 Exam | 3-4 Months"}</p>
                            <p>
                                Earn up to 15+ LPA in just 4 months!  <br />
                                Jobs at Fortune 500 Companies, Big 4, Global Banks & MNCs
                            </p>

                            <Button
                                className="courseCard-button primary-button"
                                type="primary"
                                onClick={(e) => showModal(id!, e)}
                            >
                                Enroll Now
                            </Button>

                            {isModalVisible && (
                                <EnrollModal
                                    visible={isModalVisible}
                                    onClose={handleCloseModal}
                                    courseId={selectedCourseForEnroll}
                                />
                            )}
                        </div>

                        {/* Right Form */}
                        <div className="course-hero-content right-form">
                            <h2>  Make an Enquiry</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={submitHandler}
                                initialValues={{
                                    name: '',
                                    phone: '',
                                    email: '',
                                    message: '',
                                }}
                            >
                                <Row gutter={24}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Name"
                                            name="name"
                                            rules={[{ required: true, message: 'Please enter your name' }]}
                                        >
                                            <Input placeholder="Your Name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone"
                                            name="phone"
                                            rules={[{ required: true, message: 'Please enter your phone' }]}
                                        >
                                            <Input placeholder="Your phone" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{ required: true, message: 'Please enter your email' }]}
                                        >
                                            <Input type="email" placeholder="Email Address" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Message"
                                            name="message"
                                            rules={[{ required: true, message: 'Please enter your message' }]}
                                        >
                                            <Input.TextArea rows={3} placeholder="Your message" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <FormItem>
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>

                <div className='main-section-course' style={{ padding: "20px" }}>
                    <div className='course-details-section'>
                        <div className='course-details-text'>
                            <ul style={{ listStyle: "none" }} className="course-details-description">
                                {courseDetails?.course_description?.map((desc: string, idx: number) => (
                                    <li key={idx} dangerouslySetInnerHTML={{ __html: desc }} />
                                ))}
                            </ul>

                        </div>
                        <div className="course-details-image">
                            <img
                                src={courseDetails?.course_certificate_image || defalut}
                                alt="CTP course Kerala"
                                style={{
                                    height: '400px',
                                    width: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>


                    </div>

                    <div>
                        <br />
                        <h2 className="homepage-heading">About Certified Treasury Professional</h2>


                        <div className="course-details-tabs-container">
                            <div className="course-details-tabs">
                                <Tabs
                                    activeKey={activeTab}
                                    onChange={setActiveTab}
                                    type="card"
                                    className="custom-tabs"
                                    items={tabItems}
                                    centered
                                />
                            </div>
                        </div>


                        <Modal
                            title="Check Eligibility"
                            open={isEligibilityModalOpen}
                            onCancel={() => setIsEligibilityModalOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <EligibilityCheckForm
                                courseId={id ? Number(id) : 0}
                                onClose={() => setIsEligibilityModalOpen(false)}
                            />
                        </Modal>
                    </div>

                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <img src={whycfe} alt="Treasury professional course India" className="home-why-image" />
                        </div>
                        <div className="home-why-right">
                            <h2 className="homepage-heading">Why Certified Treasury Professional (CTP)?  </h2>
                            <ul className="home-why-list">
                                {whyctptexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>

                        </div>
                    </div>
                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <h2 className="homepage-heading">Why Meantoir? </h2>
                            <ul className="home-why-list">
                                {whyTexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="home-why-right">
                            <img src={why1} alt="Treasury professional course India" className="home-why-image" />
                        </div>
                    </div>
                </div>
                <div className="ea-section-container">

                    <div>


                        <div style={{ textAlign: "center" }}>
                            <h2 style={{ width: "100%", textAlign: "center", fontSize: "2.5rem", }}>Frequently Asked Questions(FAQ's)</h2>
                        </div>
                        <div >
                            <div>
                                <h3 onClick={() => toggleSection("whatIsCTP")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q1: What is the Certified Treasury Professional (CTP) certification?
                                </h3>
                                {openSection === "whatIsCTP" && (
                                    <p style={{ width: "100%", fontSize: "1.5rem", }}>
                                        The <b>Certified Treasury Professional (CTP)</b> is a globally recognized certification offered
                                        by the <b>Association for Financial Professionals (AFP)</b>. It validates expertise in treasury management, cash management, liquidity management,
                                        working capital, corporate finance, financial risk management, and treasury operations
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("whoShouldPursue")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q2: Who should pursue the CTP certification?
                                </h3>
                                {openSection === "whoShouldPursue" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            CTP is ideal for treasury professionals, finance managers, accountants, bankers,
                                            corporate finance professionals, financial analysts, cash managers, CFOs, controllers, auditors,
                                            risk professionals, and graduates seeking a career in treasury and corporate finance.
                                        </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("eligibilityReq")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q3:Is CTP recognized globally?
                                </h3>
                                {openSection === "eligibilityReq" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            Yes. CTP is one of the <b>world's most respected treasury certifications,</b>
                                            recognized by Fortune 500 companies,
                                            multinational corporations, global banks, and financial institutions worldwide.
                                        </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("eligibility")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q4: What are the eligibility requirements for CTP?
                                </h3>
                                {openSection === "eligibility" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Candidates must satisfy the AFP eligibility requirements, which are based on a combination of education and relevant professional work experience in treasury, finance, accounting, banking, or related fields.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("freshGraduates")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q5: Can fresh graduates apply for CTP?
                                </h3>
                                {openSection === "freshGraduates" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Fresh graduates may be eligible if they meet AFP's eligibility criteria. Candidates who do not yet meet the experience requirement can gain relevant work experience before applying.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("prepareTime")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q6: How long does it take to prepare for the CTP exam?
                                </h3>
                                {openSection === "prepareTime" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Most candidates prepare for the CTP examination within 3–4 months with structured coaching and consistent study.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("topicsCovered")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q7: What topics are covered in the CTP exam?
                                </h3>
                                {openSection === "topicsCovered" && (
                                    <ul>
                                        <li>Treasury Management</li>
                                        <li>Cash Management</li>
                                        <li>Liquidity Management</li>
                                        <li>Working Capital Management</li>
                                        <li>Corporate Finance</li>
                                        <li>Financial Risk Management</li>
                                        <li>Capital Markets</li>
                                        <li>Treasury Operations</li>
                                        <li>Payments & Collections</li>
                                        <li>Treasury Controls</li>
                                        <li>Treasury Technology</li>
                                        <li>Ethics & Professional Responsibility</li>
                                    </ul>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("examPattern")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q8: What is the CTP exam pattern?
                                </h3>
                                {openSection === "examPattern" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        The CTP examination consists of 170 multiple-choice questions (150 scored and 20 unscored pretest questions) and must be completed within 3.5 hours.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("passingScore")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q9: What is the passing score for the CTP exam?
                                </h3>
                                {openSection === "passingScore" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Candidates must achieve the minimum scaled passing score established by AFP to earn the CTP certification.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("whereConducted")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q10: Where is the CTP exam conducted?
                                </h3>
                                {openSection === "whereConducted" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        The CTP examination is conducted at Pearson VUE Testing Centers during AFP's official testing windows.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("careerOpportunities")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q11: What career opportunities are available after CTP?
                                </h3>
                                {openSection === "careerOpportunities" && (
                                    <ul>
                                        <li>Treasury Analyst</li>
                                        <li>Treasury Manager</li>
                                        <li>Corporate Treasurer</li>
                                        <li>Cash Manager</li>
                                        <li>Treasury Consultant</li>
                                        <li>Financial Analyst</li>
                                        <li>Liquidity Manager</li>
                                        <li>Finance Manager</li>
                                        <li>Treasury Operations Manager</li>
                                        <li>Financial Risk Manager</li>
                                    </ul>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("companiesHire")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q12: Which companies hire CTP-certified professionals?
                                </h3>
                                {openSection === "companiesHire" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Leading Fortune 500 companies, multinational corporations (MNCs), global banks, investment banks, Big 4 firms, consulting firms, manufacturing companies, healthcare organizations, technology companies, and financial institutions actively recruit CTP-certified professionals.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("worthPursuing")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q13: Is CTP worth pursuing?
                                </h3>
                                {openSection === "worthPursuing" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Yes. CTP is considered the gold standard in treasury management, helping professionals advance into leadership roles while improving career opportunities, professional credibility, and earning potential.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("ctpVsCfa")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q14: What is the difference between CTP and CFA?
                                </h3>
                                {openSection === "ctpVsCfa" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        CFA focuses on investment management, portfolio management, and equity research, whereas CTP specializes in treasury management, cash management, liquidity, working capital, and corporate finance.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("ctpVsCpa")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q15: What is the difference between CTP and CPA?
                                </h3>
                                {openSection === "ctpVsCpa" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        CPA focuses on accounting, auditing, taxation, and financial reporting, while CTP specializes in treasury operations, corporate liquidity, cash flow management, financial risk, and treasury strategy.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("workExpMandatory")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q16: Is work experience mandatory for CTP?
                                </h3>
                                {openSection === "workExpMandatory" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Yes. AFP requires candidates to meet specific work experience and education requirements before becoming eligible for the CTP certification.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("examCost")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q17: How much does the CTP certification cost?
                                </h3>
                                {openSection === "examCost" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        The examination fee varies depending on your AFP membership status and registration period (Early or Standard). Contact Meantoir Global Academy for the latest pricing and enrollment guidance.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("coaching")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q18: Does Meantoir Global Academy provide CTP coaching?
                                </h3>
                                {openSection === "coaching" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Yes. Meantoir Global Academy, Kochi, Kerala, offers comprehensive CTP coaching with expert faculty, updated AFP-aligned study materials, mock exams, and career guidance.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("placement")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q19: Does Meantoir provide placement assistance?
                                </h3>
                                {openSection === "placement" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Yes. We provide 100% placement assistance, including resume preparation, LinkedIn profile optimization, interview coaching, and career mentoring for treasury and finance roles.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("whyMeantoir")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q20: Why choose Meantoir Global Academy for CTP coaching?
                                </h3>
                                {openSection === "whyMeantoir" && (
                                    <p style={{ fontSize: "1.5rem" }}>
                                        Simply contact Meantoir Global Academy for a FREE CTP eligibility assessment, personalized counseling, upcoming batch schedules, and enrollment assistance. Our experts will guide you throughout your CTP certification journey.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <h2 className="homepage-heading">Explore More Courses</h2>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>

                    <CourseDisplayCard />
                </div>

            </div>
            <Footer />
        </div>
    );
}

export default Ctp;
